import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { TOKENS } from '../tokens';

const STORY_WORDS = [
  { text: 'You',          gold: false },
  { text: 'have',         gold: false },
  { text: 'been',         gold: false },
  { text: 'searching',    gold: false },
  { text: 'for',          gold: false },
  { text: 'the',          gold: false },
  { text: 'right',        gold: false },
  { text: 'investment.',  gold: true  },
  { text: 'Something',    gold: false },
  { text: 'rare.',        gold: false },
  { text: 'Something',    gold: false },
  { text: 'in',           gold: false },
  { text: 'the',          gold: false },
  { text: 'heart',        gold: false },
  { text: 'of',           gold: false },
  { text: 'Delhi.',       gold: true  },
  { text: 'Today,',       gold: false },
  { text: 'you',          gold: false },
  { text: 'found',        gold: false },
  { text: 'it.',          gold: true  },
];

export default function StoryReveal() {
  const [litCount, setLitCount] = useState(0);
  const { ref, inView } = useInView({ threshold: 0.45, triggerOnce: true });

  useEffect(() => {
    if (!inView) return;
    let i = 0;
    const interval = setInterval(() => {
      i++;
      setLitCount(i);
      if (i >= STORY_WORDS.length) clearInterval(interval);
    }, 80);
    return () => clearInterval(interval);
  }, [inView]);

  return (
    <section style={{
      background: '#050A1A',
      padding: 'clamp(80px, 12vw, 160px) 24px',
      textAlign: 'center',
    }}>
      {/* Chapter tag */}
      <motion.div
        initial={{ opacity: 0, y: 14 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.5 }}
        transition={{ duration: 0.7 }}
        style={chapterTagStyle}
      >
        <span style={chapterLine} /> Chapter 01 · The Discovery
      </motion.div>

      <div
        ref={ref}
        style={{
          maxWidth: 820,
          margin: '0 auto',
          fontFamily: "'Cormorant Garamond', serif",
          fontSize: 'clamp(1.8rem, 3.5vw, 3rem)',
          fontWeight: 300,
          lineHeight: 1.4,
          color: 'rgba(255,255,255,0.12)',
        }}
      >
        {STORY_WORDS.map((w, i) => (
          <span
            key={i}
            style={{
              display: 'inline-block',
              marginRight: '0.28em',
              color: i < litCount
                ? (w.gold ? TOKENS.GOLD : '#fff')
                : 'rgba(255,255,255,0.12)',
              transition: 'color 0.35s ease',
              textShadow: i < litCount && w.gold
                ? `0 0 20px rgba(200,169,106,0.4)`
                : 'none',
            }}
          >
            {w.text}
          </span>
        ))}
      </div>
    </section>
  );
}

const chapterTagStyle = {
  display: 'inline-flex', alignItems: 'center', gap: 10,
  fontSize: '0.62rem', fontWeight: 500,
  letterSpacing: '0.22em', textTransform: 'uppercase',
  color: '#C8A96A',
  marginBottom: 32,
};
const chapterLine = { display: 'inline-block', width: 24, height: 1, background: '#C8A96A' };
